import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { TableCell, TableRow, Typography, styled } from '@mui/material';
import VisaOptionHead from './TableHead/VisaOptionHead';
import VisaOptionItem from './TableItems/VisaOptionItem';
import StateItem from './TableItems/StateItem';
import StateHead from './TableHead/StateHead';
import DamaHead from './TableHead/DamaHead';
import DamaItem from './TableItems/DamaItem';
import BacklogItem from './TableItems/BacklogItem';
import BacklogHead from './TableHead/BacklogHead';
import EoiItem from './TableItems/EoiItem';
import EoiHead from './TableHead/EoiHead';
import AnzHead from './TableHead/AnzHead';
import AnzItem from './TableItems/AnzItem';


export default function GeneralTable({ data, setData, section }) {

    const MainTableContainer = styled(Paper)(
        ({ theme }) => `
            width: 100%;
            box-shadow: none !important;
            margin-bottom: ${theme.spacing[2]};
            border: 1px solid #e0e0e0;
        `
    )

    return (
        <Box sx={{ width: '100%' }}>
            <MainTableContainer>
                <TableContainer>
                    <Table sx={{ minWidth: "auto", background: "white" }}>
                            {
                                section == "visaOption" && <VisaOptionHead /> ||
                                section == "stateTerritory" && <StateHead /> ||
                                section == "damaResult" && <DamaHead /> ||
                                section == "backlogResult" && <BacklogHead /> ||
                                section == "eoiData" && <EoiHead /> ||
                                section == "anzsco" && <AnzHead /> 
                            }
                        <TableBody>
                            {
                                data.length != 0 ?
                                (
                                    data.map((val, i) => {
                                        return (
                                            section == "visaOption" && <VisaOptionItem data={val} index={i + 1} key={i} /> ||
                                            section == "stateTerritory" && <StateItem data={val} index={i + 1} key={i} /> ||
                                            section == "damaResult" && <DamaItem data={val} index={i + 1} key={i} /> ||
                                            section == "backlogResult" && <BacklogItem data={val} index={i + 1} key={i} /> ||
                                            section == "eoiData" && <EoiItem data={val} index={i + 1} key={i} /> ||
                                            section == "anzsco" && <AnzItem data={val} index={i + 1} key={i} />
                                        )
                                    })
                                ) : null
                            }
                            {
                                data.length == 0 && 
                                    <TableRow>
                                        <TableCell colSpan="6"><Typography sx={{width: "100%", textAlign: "center", p: 1}} variant='h6' color="#B2B2B2">موردی وجود ندارد</Typography></TableCell>
                                    </TableRow>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </MainTableContainer>
        </Box>
    )
}